import React from 'react';
import { observer } from 'mobx-react';
import ReplyStore from '../../stores/reply';
import Content from './content';
import { Spin } from 'antd';
import { WeaLocaleProvider } from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;

export interface ReplyProps {
    reply: ReplyStore;
}

@observer
export default class ReplySingleBase extends React.Component<ReplyProps, any> {
    render() {
        const { reply } = this.props;
        return (
            <Spin spinning={reply.loading} tip={getLabel(31230,"加载中")+"..."}>
                <div className="cube-reply">
                    {
                        reply && <Content isSingleReply={1} {...this.props} />
                    }
                </div>
            </Spin>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/reply/replySingle.tsx